import React, { PureComponent } from "react";
//import { TouchableOpacity, View, Text } from "react-native";
import PropTypes from "prop-types";
// import { connect } from "react-redux";

import styles from "./style.css";
// import fontFamily from "app/styles/fonts";
import { getDurationString } from "../../../../uq-ui/helpers/duration";
// import { orientationSelector } from "../../../../layout/store/selectors";


class StickersComponentsRecordVideoBtn extends PureComponent {

  durationInterval;

  static defaultProps = {
    onPress: () => { },
    isRecording: false,
    // orientation: null,
    maxDuration: 0,
  };

  static propTypes = {
    onPress: PropTypes.func,
    isRecording: PropTypes.bool,
    maxDuration: PropTypes.number,
    // orientation: PropTypes.string,
    containerClassNames: PropTypes.any
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.isRecording && this.state.currentDuration === 0) {
      if (this.durationInterval) { clearInterval(this.durationInterval) }

      this.setState({ currentDuration: this.state.currentDuration + 1 });
      this.durationInterval = setInterval(() => {
        this.setState({ currentDuration: this.state.currentDuration + 1 });
      }, 1000);
    }
    if (!nextProps.isRecording && this.durationInterval != null) {
      clearInterval(this.durationInterval);
      this.durationInterval = null;
      this.setState({ currentDuration: 0 });
    }
  }

  componentWillUnmount() {
    if (this.durationInterval) {
      clearInterval(this.durationInterval);
      this.durationInterval = null;
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      currentDuration: 0
    };
  }

  render() {
    const durationString = getDurationString(this.props.maxDuration - this.state.currentDuration) || '0:00';
    return (
      <div className={styles.container}>
        {this.props.isRecording && (
          <div className={styles.duration}>{durationString}</div>
        )}
        <div onClick={this.props.onPress}
             className={styles.btn}>
          <div className={styles.inner}>
            {this.props.isRecording && (
              <div className={styles.recordingIcon} />
            )}
            {!this.props.isRecording && (
              <div className={styles.recordIcon} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default StickersComponentsRecordVideoBtn;


// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/components/record-video-btn/index.jsx